<template>
<v-parallax
    dark
    height="974"
    :src="require('../assets/home-page-header-bg.png')"
  >
  <v-container>
    <v-row no-gutters>
      <v-col cols="12">
        <v-row justify="center" align="center">          
            <v-col cols="12" class="text-center">
              <h1>Motivate Your Healthy Lifestyle</h1>
            </v-col>       
            <v-col cols="12">          
              <v-img height="740" contain :src="require('../assets/home-page-header-phones.png')"></v-img>
            </v-col>      
            <v-col cols="12" class="text-center">        
              <v-btn  color="primary" @click="ScrollTo('#Pricing')">Sign Me Up Now</v-btn>
            </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</v-parallax>
</template>

<script>
export default {
  data: () => ({
  }),
  methods: {
    ScrollTo(link) {      
      this.$vuetify.goTo(link, {
        duration: 500,
        easing: 'easeInOutCubic',
      })
    }
  }
};
</script>
<style scoped>
.v-parallax__image {
  transform: none !important;
  width: 100% !important;
}
</style>
